import { render } from "./ProductCategoryBestSeller.vue?vue&type=template&id=60770a5a&scoped=true"
import script from "./ProductCategoryBestSeller.vue?vue&type=script&lang=js"
export * from "./ProductCategoryBestSeller.vue?vue&type=script&lang=js"

import "./ProductCategoryBestSeller.vue?vue&type=style&index=0&id=60770a5a&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60770a5a"]])

export default __exports__